module.exports = __webpack_public_path__ + "static/img/009.9b4df6b8.png";